// extracted by mini-css-extract-plugin
export var closeButton = "_by-1";
export var closeX = "_by-3";
export var container = "_by-0";
export var image = "_by-2";